import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamilyContext } from '@/contexts/FamilyContext';
import { TESTING_MODE } from '@/lib/testing-mode';
import LandingPage from './LandingPage';

const Index = () => {
  const { user, loading } = useFamilyContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (TESTING_MODE || (!loading && user)) {
      navigate('/parent');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LandingPage />;
  }

  return null;
};

export default Index;
